import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBuildingColumns,
  faCopy,
  faFileArrowDown,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";

function CopyRow({ label, value, onCopy, copied }) {
  return (
    <div className="new-bank-overview__detail-row">
      <div className="new-bank-overview__detail-copy">
        <div>
          <span>{label}</span>
          <strong>{value || "-"}</strong>
        </div>

        <button
          type="button"
          className="new-bank-overview__icon-button"
          onClick={() => onCopy(value)}
          aria-label={`Copy ${label}`}
          disabled={!value}
        >
          <FontAwesomeIcon icon={faCopy} />
        </button>
      </div>

      {copied ? <small>Copied</small> : null}
    </div>
  );
}

export default function BankDetailsCard({
  iban,
  bicSwift,
  onDownloadCertificate,
}) {
  const [copiedField, setCopiedField] = useState("");
  const copyTimerRef = useRef(null);
  const canDownloadCertificate =
    String(iban ?? "").trim() !== "" &&
    String(bicSwift ?? "").trim() !== "";

  useEffect(() => {
    return () => {
      if (copyTimerRef.current) {
        window.clearTimeout(copyTimerRef.current);
      }
    };
  }, []);

  const handleCopy = async (value, field) => {
    if (!value) return;

    try {
      await navigator.clipboard.writeText(value);
      setCopiedField(field);
      if (copyTimerRef.current) {
        window.clearTimeout(copyTimerRef.current);
      }
      copyTimerRef.current = window.setTimeout(() => {
        setCopiedField("");
      }, 1200);
    } catch (error) {
      toast.error("Unable to copy bank details right now.");
    }
  };

  return (
    <article className="new-bank-overview__card new-bank-overview__details-card">
      <div className="new-bank-overview__details-head">
        <div className="new-bank-overview__details-title">
          <span className="new-bank-overview__details-icon" aria-hidden="true">
            <FontAwesomeIcon icon={faBuildingColumns} />
          </span>
          <strong>Bank Details</strong>
        </div>

        <button
          type="button"
          className="new-bank-overview__ghost-button"
          onClick={onDownloadCertificate}
          disabled={!canDownloadCertificate}
        >
          <FontAwesomeIcon icon={faFileArrowDown} />
          <span>Download Certificate</span>
        </button>
      </div>

      <div className="new-bank-overview__details-body">
        <CopyRow
          label="IBAN"
          value={iban}
          copied={copiedField === "iban"}
          onCopy={(value) => handleCopy(value, "iban")}
        />
        <CopyRow
          label="BIC/SWIFT"
          value={bicSwift}
          copied={copiedField === "bic"}
          onCopy={(value) => handleCopy(value, "bic")}
        />
      </div>
    </article>
  );
}
